import { Injectable } from "@angular/core";
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { ConfirmDialogEventType, ConfirmDialogSeverity } from '../../../components/confirmDialog/confirmDialogComponent';
import { ConfirmDialogService } from '../../../components/confirmDialog/confirmDialogService';
import { CommandInput, CommandTemplate } from "../../../entities/commandTemplate/commandTemplate";
import { CommandService, Flow, HasCommands } from "../command.service";

@Injectable({
    providedIn: 'root'
  })
export class ConfirmationDialogFlow implements Flow {

    dialogRef: DynamicDialogRef | undefined;

    constructor(
        private confirmDialogService: ConfirmDialogService
        // private loadingService: LoadingService
    ) { }

    executeFlow(commandService: CommandService, hasCommands: HasCommands,
      commandTemplate: CommandTemplate, commandInput: CommandInput,
      completionCallback: () => void) {

        // build the dialog
        const message = commandTemplate.flow?.settings?.message;
        const cancelLabel = commandTemplate.flow?.settings?.cancelLabel;
        const confirmLabel = commandTemplate.flow?.settings?.confirmLabel;
        const title = commandTemplate.flow?.settings?.title;
        const confirmDialogSeverity = this.getSeverityfromString(commandTemplate.flow?.settings?.severity);

        this.dialogRef = this.confirmDialogService.open({
            message: message,
            severity: confirmDialogSeverity,
            header: title,
            cancelLabel: cancelLabel,
            confirmLabel: confirmLabel
          });
        this.dialogRef.onClose.subscribe( (result : ConfirmDialogEventType) => {
          if(result === ConfirmDialogEventType.CONFIRM){

            // this.loadingService.setLoading(true);

            commandService.sendCommand(commandInput, () => {
              completionCallback();
            })

            // this.loadingService.setLoading(true);
          };
        })
    }

    getSeverityfromString(value: string): ConfirmDialogSeverity {
      if (Object.values(ConfirmDialogSeverity).includes(value as ConfirmDialogSeverity)) {
          return value as ConfirmDialogSeverity;
      }
      return ConfirmDialogSeverity.DEFAULT; // Standardwert
    }

  }
